import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Form } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import TradingName from './TradingName';
import ActivityTypes from './ActivityTypes';
import NeedLicence from './NeedLicence';
import TypeOfLicense from './TypeOfLicense';
import NumberOfPeople from './NumberOfPeople';
import IndustryComponent from './IndustryComponent';
import RegisteredName from './RegisteredName';
import RegisteredNumber from './RegisteredNumber';
import DateField from '../../../components/DateField';
import FocusHOC from '../../../components/FocusHOC';

import {
  REGISTER_ADDRESS_TYPE,
  TRADING_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE,
  MULTIPLE_ADDRESS_TRADING,
  MULTIPLE_ADDRESS_MAILING,
  REGISTER_ADDRESS_SELECTOR
} from '../../../utils/constants';
import Submit from '../../../components/Submit';
import { getSelectedAddress } from '../../../components/Address/addressUtils/addressUtils';
import {
  renderRegisterAddress,
  renderTradingAddress,
  renderMailingAddress
} from './AddressComponents/GetAddresses';
import { onKeyPress } from '../../../utils';
import {
  getInitialValues,
  getInitialValuesMultiParty,
  setAboutBusinessSubmitted,
  isAboutBusinessFormSubmitted
} from '../utils/aboutBusinessPageUtils';

class AboutBusinessPage extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.getExistingAddres = this.getExistingAddres.bind(this);
  }

  submit(data) {
    const mergedData = Object.assign(data, this.chosenAddress);
    this.props.saveBusinessForm(mergedData);
  }

  getExistingAddres(type) {
    switch (type) {
      case REGISTER_ADDRESS_TYPE:
        return this.props.editButtonClicks.registerEditClick ? this.props.registerAddress : '';
      case TRADING_ADDRESS_TYPE:
        return this.props.editButtonClicks.tradingEditClick ? this.props.tradingAddress : '';
      default:
        return '';
    }
  }

  render() {
    const {
      isSoleBusinessType,
      getBusinessData,
      address,
      decorators,
      businessId,
      onAddressSelection,
      registerAddress,
      tradingAddress,
      mailingAddress,
      saveAboutYourFormValues,
      onAddressEditClick,
      editButtonClicks
    } = this.props;

    const tadingAddressSelection = (name, value) => {
      onAddressSelection(name, value);
      saveAboutYourFormValues({ name: MULTIPLE_ADDRESS_TRADING, value });
    };

    const mailingAddressSelection = (name, value) => {
      onAddressSelection(name, value);
      saveAboutYourFormValues({ name: MULTIPLE_ADDRESS_MAILING, value });
    };
    const registeredAddressSelection = (name, value) => {
      onAddressSelection(name, value);
      saveAboutYourFormValues({ name: REGISTER_ADDRESS_SELECTOR, value });
    };
    const saveFormValues = (name, value) => {
      saveAboutYourFormValues({ name, value });
    };

    return (
      <Form
        onSubmit={this.submit}
        initialValues={
          isSoleBusinessType
            ? getInitialValues(getBusinessData)
            : getInitialValuesMultiParty(getBusinessData)
        }
        decorators={decorators}
        render={({ handleSubmit, values, valid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              onKeyPress={onKeyPress}
              onChange={(e) => {
                e.target &&
                  e.target.name &&
                  e.target.name.includes('incorporationDate') &&
                  saveAboutYourFormValues({ name: e.target.name, value: e.target.value });
                if (valid) {
                  setAboutBusinessSubmitted();
                }
              }}
            >
              <StandardBody>
                <Content>
                  {({ businessHeader = '' }) => <PageHeading>{businessHeader}</PageHeading>}
                </Content>
                {!isSoleBusinessType && (
                  <div>
                    <RegisteredName
                      isSubmitted={isAboutBusinessFormSubmitted()}
                      onChange={(name, value) => {
                        saveAboutYourFormValues({ name, value });
                      }}
                    />
                    <RegisteredNumber
                      isSubmitted={isAboutBusinessFormSubmitted()}
                      onChange={(name, value) => {
                        saveAboutYourFormValues({ name, value });
                      }}
                    />
                    <DateField
                      isSubmitted={isAboutBusinessFormSubmitted()}
                      dateHeader="incorporationDate"
                      label="registeredDate"
                    />
                    {renderRegisterAddress(
                      registerAddress,
                      editButtonClicks.registerEditClick,
                      address,
                      registeredAddressSelection,
                      values,
                      onAddressEditClick,
                      saveFormValues
                    )}
                  </div>
                )}

                <TradingName
                  values={values}
                  businessType={isSoleBusinessType}
                  onChange={(name, value) => {
                    saveAboutYourFormValues({ name, value });
                  }}
                />
                {renderTradingAddress(
                  tradingAddress,
                  editButtonClicks.tradingEditClick,
                  address,
                  tadingAddressSelection,
                  values,
                  isSoleBusinessType,
                  onAddressEditClick,
                  this.getExistingAddres,
                  saveFormValues
                )}

                {renderMailingAddress(
                  mailingAddress,
                  editButtonClicks.mailingEditClick,
                  address,
                  mailingAddressSelection,
                  values,
                  isSoleBusinessType,
                  onAddressEditClick,
                  this.getExistingAddres,
                  saveFormValues
                )}
                {setChoosenAddressFields(
                  values,
                  TRADING_ADDRESS_TYPE,
                  getSelectedAddress(values, values.mutipleAddressTrading, address)
                )}
                {setChoosenAddressFields(
                  values,
                  MAILING_ADDRESS_TYPE,
                  getSelectedAddress(values, values.mutipleAddressMailing, address)
                )}
                <IndustryComponent
                  formFieldValues={values}
                  isSubmitted={isAboutBusinessFormSubmitted()}
                  businessId={businessId}
                  isSoleBusinessType={isSoleBusinessType}
                  onChange={(name, value) => {
                    saveAboutYourFormValues({ name, value });
                  }}
                />
                <ActivityTypes
                  formFieldValues={values}
                  isSubmitted={isAboutBusinessFormSubmitted()}
                  onChange={(name, value) => {
                    saveAboutYourFormValues({ name, value });
                  }}
                />
                <NeedLicence values={values} saveAboutYourFormValues={saveAboutYourFormValues} />
                {values.needLicence === 'Yes' && (
                  <TypeOfLicense
                    values={values}
                    onChange={(name, value) => {
                      saveAboutYourFormValues({ name, value });
                    }}
                  />
                )}
                <NumberOfPeople
                  isSubmitted={isAboutBusinessFormSubmitted()}
                  onChange={(name, value) => {
                    saveAboutYourFormValues({ name, value });
                  }}
                />
                <Submit />
              </StandardBody>
            </form>
          );
        }}
      />
    );
  }
}

AboutBusinessPage.propTypes = {
  isSoleBusinessType: PropTypes.bool.isRequired,
  saveBusinessForm: PropTypes.func.isRequired
};

const setChoosenAddressFields = (formValues, type, value) => {
  formValues[`${type}chosenAddressField`] = value;
};

export default FocusHOC(AboutBusinessPage);
